import type { ReactNode } from 'react';

export const symbol_mountain_flag: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m327-445 75 50 64-32q6-3 13.5-3t13.5 3l64 33 75-50-47-96H374l-47 95ZM177-140h606L659-390l-82 55q-6.6 5.14-14.3 5.57Q555-329 547-333l-67-33-67 33q-8 4-15.5 3.5T383-335l-83-56-123 251Zm-49 60q-17.5 0-26.25-14t-.75-29l219-444q8-15 22.47-24 14.47-9 31.53-9h76v-250q0-12.75 8.63-21.38Q467.25-880 480-880h200q8.13 0 12.57 7 4.43 7 .43 15l-21 41q-2 3-2 7t2 7l21 41q4 8-.43 15-4.44 7-12.57 7H510v140h73q16.93 0 30.92 9 13.98 9 22.08 24l222 444q8 15-.75 29T831-80H128Zm352-286Z"
		/>
	</svg>
);
